// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"282916e8","540":"1267522e","732":"cdd02d50"}[chunkId] + ".chunk.js";
};